import { render, staticRenderFns } from "./ContentActionsPopup.vue?vue&type=template&id=0770fa3d&scoped=true"
import script from "./ContentActionsPopup.vue?vue&type=script&lang=js"
export * from "./ContentActionsPopup.vue?vue&type=script&lang=js"
import style0 from "./ContentActionsPopup.vue?vue&type=style&index=0&id=0770fa3d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0770fa3d",
  null
  
)

export default component.exports